<h3>Edit Address</h3>
<mat-dialog-content>
    <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Street</mat-label>
            <input matInput placeholder="" [(ngModel)]="address.street">
            <mat-hint>Currently set as <i>{{data.street}}</i></mat-hint>
        </mat-form-field>
    </div>
    <div class="form-row row-3">
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>City</mat-label>
            <input matInput autocomplete="home city" max="100" [(ngModel)]="address.city">
            <mat-error *ngIf="!address.city.length">
                City is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
            <mat-label>State</mat-label>
            <mat-select [(ngModel)]="address.state">
                <mat-option [value]="null">Select a State</mat-option>
                <mat-option *ngFor="let state of states" [value]="state.code">
                    {{ state.name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="!address.state.length">
                State is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Zip Code</mat-label>
            <input matInput autocomplete="postal-code" [(ngModel)]="address.zipCode">
            <mat-error *ngIf="!address.zipCode.length">
                Zip Code is required
            </mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="cancel.emit()"><mat-icon matPrefix>cancel</mat-icon>Canel</button>
    <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="save.emit(address)"><mat-icon matPrefix>save</mat-icon>Save</button>
</mat-dialog-actions>